export class Password {

    _pattern = /[a-zA-Z0-9\-!_@#%*^.()]/;
    _patternNumber = /[0-9]/;
    _patternUppercase = /[A-Z]/;
    _patternLowerrcase = /[a-z]/;
    _patternCharacter = /[-!_@#%*^.()]/;

    _getRandomByte() {
        if (window.crypto && window.crypto.getRandomValues) {
            const result = new Uint8Array(1);
            window.crypto.getRandomValues(result);
            return result[0];
        } else if (window['msCrypto'] && window['msCrypto'].getRandomValues) {
            const result = new Uint8Array(1);
            window['msCrypto'].getRandomValues(result);
            return result[0];
        } else {
            return Math.floor(Math.random() * 256);
        }
    }

    generate(length) {
        const passwordLength = length;
        let hasNumber: boolean;
        let hasUpper: boolean;
        let hasLower: boolean;
        let hasCharacter: boolean;

        const password = Array.apply(null, {'length': length})
            .map((currentItem: any, lengthIndex: number) => {
                let result;
                const countOfPatterns = 4;
                while (true) {
                    result = String.fromCharCode(this._getRandomByte());
                    const testResult = this._pattern.test(result);

                    if ((lengthIndex === (passwordLength - countOfPatterns)) && !hasCharacter) {
                        if (this._patternCharacter.test(result)) {
                            break;
                        }
                    } else {
                        if ((lengthIndex === (passwordLength - countOfPatterns + 1)) && !hasNumber) {
                            if (this._patternNumber.test(result)) {
                                break;
                            }
                        } else {
                            if ((lengthIndex === (passwordLength - countOfPatterns + 2)) && !hasUpper) {
                                if (this._patternUppercase.test(result)) {
                                    break;
                                }
                            } else {
                                if ((lengthIndex === (passwordLength - countOfPatterns + 3)) && !hasLower) {
                                    if (this._patternLowerrcase.test(result)) {
                                        break;
                                    }
                                } else {
                                    if (testResult) {
                                        if (!hasNumber) {
                                            hasNumber = this._patternNumber.test(result);
                                        }

                                        if (!hasUpper) {
                                            hasUpper = this._patternUppercase.test(result);
                                        }

                                        if (!hasLower) {
                                            hasLower = this._patternLowerrcase.test(result);
                                        }

                                        if (!hasCharacter) {
                                            hasCharacter = this._patternCharacter.test(result);
                                        }
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                return result;
            });
        if (password && (password instanceof Array)) {
            return password.join('');
        } else {
            return this.generate(length);
        }
    }
}

export class PasswordFactory {
    static generatePassword(length: number) {
        return (new Password).generate(length);
    }
}
